import { INACCURACY } from 'constants/params';
import { RootState } from 'store/store';
import { useAppDispatch, useAppStore } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { PanZoomIndex, setPanZoomKeyFrameIndex } from 'components/app/editor/_mediator/editor.slice';
import { useSbContext } from 'components/app/storyboard/_mediator/sb.provider';
import { useSbCb } from 'components/app/storyboard/_mediator/use-sb-cb';
import { EnumFader, useSbPlayerCb } from 'components/app/storyboard/sb-player/_mediator/use-sb-player-cb';
import { getPlayerTime } from '../sb-player/_mediator/sb-player.helper';
import { useSbPlayerContext } from '../sb-player/_mediator/sb-player.provider';

export const useSbPanZoomSeek = () => {
  const { sbListenPanZoom } = useSbContext();
  const { sbPlayerSeekTo } = useSbPlayerContext();
  const { sbSelectClip, sbSeekTo } = useSbCb();
  const { toggleFader } = useSbPlayerCb();
  const { path } = useLocation();
  const store = useAppStore();
  const dispatch = useAppDispatch();

  return (index: PanZoomIndex) => {
    dispatch(setPanZoomKeyFrameIndex(index));

    const {
      cell,
      track,
      markers,
      duration,
      sbPlayback,
      transitionTime,
      sbClipPlaybackMap,
      dampingPlayerIndex,
      activeClip: clipId,
      activePlayerIndex,
    } = selectData(store.getState());
    if (path !== Path.storyboard || sbPlayback) return;
    if (!clipId || !markers || !duration) return;
    sbListenPanZoom.current = true;
    if (index === 0) sbSelectClip(clipId, cell, track);
    else {
      const playbackParams = sbClipPlaybackMap[clipId];
      const wsTime =
        cell === markers.length
          ? duration
          : playbackParams.linkedIndex && !playbackParams.linkedIndex.isLastInGroup
          ? markers[cell] - INACCURACY * 2
          : markers[cell] + (transitionTime ?? 0) / 1000;
      const playerTime = getPlayerTime(wsTime, playbackParams, markers, cell);
      sbPlayerSeekTo(dampingPlayerIndex ?? activePlayerIndex, playerTime);
      sbSeekTo(markers.length !== cell ? wsTime : duration);
      toggleFader(EnumFader.off);
    }
  };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { duration } = state.audio;
  const { markers, activeClip } = state.editor;
  const { sbPlayback, sbClipPlaybackMap } = state.sb;
  const { track, cell } = state.editor__controls.sbPosition;
  const { activePlayerIndex, dampingPlayerIndex } = state.sb__player;
  const transitionTime = state.editor.storyConfig?.transitionTime;
  return {
    sbPlayback,
    transitionTime,
    sbClipPlaybackMap,
    dampingPlayerIndex,
    activePlayerIndex,
    activeClip,
    duration,
    markers,
    track,
    cell,
  };
};
